import { appHttpRequest } from '@/utils/AppHttpRequest';
import { IPage } from '@/types/FmsTypes';
import {
	ISCMSaleRoSearch,
	ISCMSaleRoDetail,
	ISCMSaleRoInsert,
	ISCMSaleRoUpdate,
	ISCMSaleRoStatistics,
	ISCMSaleSoGoodsSearch,
	ISCMSaleSoGoodsDetailed,
	ISCMSaleSoDetail,
} from './scmSaleRoType';
// import { ISCMWhConfirmShopId, ISCMPoSettle } from "@/views/purchase/po/purchasePoTypes";

export interface ISCMPage<T, S> extends IPage<T> {
	statistics: S;
}

export interface ISCMDictSearch {
	page: {
		pageSize: number;
		pageNum: number;
	};
	sourceApp?: string;
}

export interface ISCMDictDetail {
	note: string;
	ver: number;
	code: string;
	sourceAuthKey?: string;
	pcode: string | null;
	children: ISCMDictDetail[];
	enable: number;
	name: string;
	branch?: string;
	value: string;
	key: string;
	status?: number;
}

class SaleRoService {
	// 供应链销售退货
	async roOne(id: string) {
		const apiUrl = `/scm2/sale/ro/findByIdOrCode/${id}`;
		return await appHttpRequest.get<ISCMSaleRoDetail>(apiUrl);
	}
	//待选则销售明细商品分页查询
	async saleSoGoodspage(searchVo: ISCMSaleSoGoodsSearch) {
		const apiUrl = '/scm2/sale/so/detail/findDetailPage';
		return await appHttpRequest.post<IPage<ISCMSaleSoGoodsDetailed>>(apiUrl, searchVo);
	}

	// 供应链数据字典
	async page(searchVo: ISCMDictSearch) {
		const apiUrl = '/scm2/dict/page';
		return await appHttpRequest.post<IPage<ISCMDictDetail>>(apiUrl, searchVo);
	}
	// 供应链数据字典
	async ngaPage(searchVo: ISCMDictSearch) {
		const apiUrl = '/ngavrm/vrm-sa/base/dict/page';
		return await appHttpRequest.post<IPage<ISCMDictDetail>>(apiUrl, searchVo);
	}
	// 供应链销售单
	async soOne(id: string) {
		const apiUrl = `/scm2/sale/so/findByIdOrCode/${id}`;
		return await appHttpRequest.get<ISCMSaleSoDetail>(apiUrl);
	}
}

export const saleRoService = new SaleRoService();
